<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M2 10C2 14.411 5.589 18 10 18C14.411 18 18 14.411 18 10C18 5.589 14.411 2 10 2C5.589 2 2 5.589 2 10ZM9.957 6.543L12.707 9.293C12.902 9.488 13 9.744 13 10C13 10.256 12.902 10.512 12.707 10.707L9.957 13.457C9.566 13.848 8.934 13.848 8.543 13.457C8.152 13.066 8.152 12.434 8.543 12.043L10.586 10L8.543 7.957C8.152 7.566 8.152 6.934 8.543 6.543C8.934 6.152 9.566 6.152 9.957 6.543Z"
            fill="currentColor"
        />
    </svg>
</template>
